"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
function ToggleButtons(_a) {
    var options = _a.options, value = _a.value, setValue = _a.setValue, _b = _a.exclusive, exclusive = _b === void 0 ? false : _b, style = _a.style;
    function handleOptionButtonClick(option, event) {
        var newValue = option;
        if (!exclusive && typeof value !== "string") {
            newValue = __spreadArrays((value || []), [newValue]);
        }
        setValue(newValue, event);
    }
    return (react_1.default.createElement(styles_1.MainContainer, { style: style && style.mainContainer }, options.map(function (option, index) {
        return (react_1.default.createElement(styles_1.ToggleButton, { key: index, isSelected: !!(value &&
                (typeof value === "string"
                    ? value === option.value
                    : value.find(function (selectedOption) { return selectedOption === option.value; }))), onClick: function (event) { return handleOptionButtonClick(option.value, event); }, customStyle: style && style.buttons }, option.label));
    })));
}
exports.default = ToggleButtons;
//# sourceMappingURL=index.js.map